import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";

import Header from "../SharedComponents/Header/Header";
import LoginGuard, { logout } from "../SharedComponents/LoginGuard/loginGuard";
import { environment } from "../utils/environment";
import {
  DoutoradoSelectCollectionController,
  DoutoradoSelectCollectionControllerDelegate,
} from "./controller";

interface State {
  collectionCode: string;
  isLoading: boolean;
  error?: string;
}

class DoutoradoSelectCollectionScreen
  extends React.Component<{}, State>
  implements DoutoradoSelectCollectionControllerDelegate
{
  private controller: DoutoradoSelectCollectionController;

  constructor(props: {}) {
    super(props);
    this.controller = new DoutoradoSelectCollectionController(this);
    this.state = {
      collectionCode: "",
      isLoading: false,
    };
  }

  submitedSuccess(): void {
    window.location.href = environment.baseUrl;
  }

  genericError(message: string): void {
    this.setState({ isLoading: false, error: message });
  }

  applicationShouldLogout(): void {
    logout();
  }

  handleCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ collectionCode: event.target.value, error: undefined });
  };

  handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    this.setState({ isLoading: true, error: undefined });
    await this.controller.assignCollection(this.state.collectionCode);
  };

  render() {
    const { isLoading, error, collectionCode } = this.state;

    return (
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        alignItems="center"
        justifyContent="center"
      >
        <LoginGuard />
        <Header logoutEnabled={true} />
        <Typography variant="h5" gutterBottom mt={4}>
          Coleta de Pesquisa
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Insira o código da coleta para iniciar.
        </Typography>
        <Box
          component="form"
          onSubmit={this.handleSubmit}
          sx={{ width: "100%", maxWidth: 400, px: 2 }}
        >
          <TextField
            label="Código da Coleta"
            variant="outlined"
            fullWidth
            value={collectionCode}
            onChange={this.handleCodeChange}
            error={!!error}
            helperText={error}
            disabled={isLoading}
          />
          <Box sx={{ position: "relative", mt: 2 }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={isLoading || !collectionCode}
              sx={{ color: "white", height: 48 }}
            >
              Confirmar
            </Button>
            {isLoading && (
              <CircularProgress
                size={24}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </Box>
      </Box>
    );
  }
}

export default DoutoradoSelectCollectionScreen;
